<template>
  <v-dialog v-model="showing_year_modal" persistent eager max-width="650">
    <v-card>
      <v-form
        ref="form"
        v-model="year_form_status"
        v-on:submit.prevent="add_form_validate"
      >
        <v-toolbar
          :color="form_mode === FORM_MODES.ADD ? 'success' : 'warning'"
          class="ps-4"
          ><h3>
            {{ $t("config_year.config_year") }} (
            {{
              form_mode === FORM_MODES.ADD
                ? $t("config.addnew")
                : $t("config.edit")
            }}
            )
          </h3>
        </v-toolbar>

        <hr />

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-text-field
                v-model="configYear_admitYear"
                :label="$t('config_year.admit_year')"
                type="number"
                :rules="configYearRules"
                :disabled="form_mode === FORM_MODES.EDIT"
            /></v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <v-autocomplete
                v-model="configYear_admitSemester"
                :label="$t('config_year.admit_semester')"
                :items="semesters"
                :item-value="(item) => item.semester"
                :item-text="(item) => item.semester"
                :rules="requiredRules"
                :disabled="form_mode === FORM_MODES.EDIT"
              ></v-autocomplete
            ></v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configYear_startDatetimeSystem"
                :label="$t('config_year.start_datetime_system')"
                :rules="requiredRules"
                minDate="2020-01-01"
                :maxDate="getYearsModified(5)"
              />
            </v-col>
            <v-col class="pt-0 pb-0" cols="12" md="6">
              <DateSelectCard
                v-model="configYear_admitDate"
                :label="$t('config_year.admit_date')"
                :rules="requiredRules"
                minDate="2020-01-01"
                :maxDate="getYearsModified(5)"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            @click="form_validate()"
            variant="flat"
            color="indigo-darken-3"
          >
            {{ $t("config.save") }}</v-btn
          >
          <v-btn @click="showing_year_modal = false" variant="outlined">{{
            $t("config.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import { getYearsModified } from "@/helper/dateTime";
import validator from "@/helper/validator";
import ConfigProvider from "@/services/config.provider";
import DateSelectCard from "@/components/info_cards/DateSelect";

const configService = new ConfigProvider();
const { mapFields: mapOfficerConfigFields } = createHelpers({
  getterType: "officerConfig/getField",
  mutationType: "officerConfig/updateField",
});

const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "ConfigYearAddEditDialog",

  props: {
    toggle_loading: Function,
  },

  data: () => ({
    FORM_MODES,
    semesters: ["1", "2", "3"],
    levels: [
      {
        LEVEL_ID: "1",
        LEVEL_NAME_EN: "ปริญญาตรี",
        LEVEL_NAME_TH: "ปริญญาตรี",
      },
      {
        LEVEL_ID: "2",
        LEVEL_NAME_EN: "บัณฑิตศึกษา (4+1, โท, เอก)",
        LEVEL_NAME_TH: "บัณฑิตศึกษา (4+1, โท, เอก)",
      },
    ],
    form_mode: null,
    year_form_status: null,
    showing_year_modal: false,

    configYear_yearId: null,
    configYear_admitYear: null,
    configYear_admitSemester: null,
    configYear_startDatetimeSystem: null,
    configYear_admitDate: null,
    configYear_levelId: null,
    configYearRules: [validator.required, validator.thaiYear],
    requiredRules: [validator.required],
  }),

  components: {
    DateSelectCard,
  },

  computed: {
    ...mapOfficerConfigFields({
      config_years: "config_years",
    }),
  },

  methods: {
    getYearsModified,

    open_add_modal: function (level_id) {
      this.form_mode = FORM_MODES.ADD;
      this.$refs.form.reset();
      this.configYear_startDatetimeSystem = null;
      this.configYear_admitDate = null;
      this.configYear_levelId = level_id;
      this.showing_year_modal = true;
    },

    open_edit_modal: function (item) {
      let start_datetime_system = item.START_DATETIME_SYSTEM;
      start_datetime_system = new Date(start_datetime_system);

      this.form_mode = FORM_MODES.EDIT;
      this.configYear_yearId = item.YEAR_ID;
      this.configYear_levelId = item.LEVEL_ID;
      this.configYear_admitYear = item.ADMIT_YEAR;
      this.configYear_admitSemester = item.ADMIT_SEMESTER;
      this.configYear_startDatetimeSystem = start_datetime_system;
      this.configYear_admitDate = new Date(item.ADMIT_DATE);
      this.showing_year_modal = true;
    },

    form_validate: function () {
      if (this.form_mode === FORM_MODES.ADD) {
        this.add_form_validate();
      } else if (this.form_mode === FORM_MODES.EDIT) {
        this.edit_form_validate();
      }
    },

    add_form_validate: async function () {
      this.$refs.form.validate();
      if (this.year_form_status) {
        this.showing_year_modal = false;
        this.toggle_loading(true);

        const start_datetime_system = this.$dayjs(
          this.configYear_startDatetimeSystem
        ).format("YYYY-MM-DD 00:00:00");
        const admit_date = this.$dayjs(this.configYear_admitDate).format(
          "YYYY-MM-DD"
        );

        let response = await configService
          .setYear({
            level_id: this.configYear_levelId,
            admit_year: this.configYear_admitYear,
            admit_semester: this.configYear_admitSemester,
            start_datetime_system: start_datetime_system,
            admit_date: admit_date,
          })
          .catch((error) => {
            this.$toast.error(JSON.stringify(error.response.data.message));
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getYears");
        if (response && response.status)
          this.$toast.success(this.$t("toast.create_successfully"));
        else this.$toast.error(this.$t("toast.cannot_create"));

        this.toggle_loading(false);
      }
    },

    edit_form_validate: async function () {
      this.$refs.form.validate();
      if (this.year_form_status) {
        this.showing_year_modal = false;
        this.toggle_loading(true);

        const start_datetime_system = this.$dayjs(
          this.configYear_startDatetimeSystem
        ).format("YYYY-MM-DD");
        const admit_date = this.$dayjs(this.configYear_admitDate).format(
          "YYYY-MM-DD"
        );

        let response = await configService
          .setYear({
            // id: this.configYear_id,
            level_id: this.configYear_levelId,
            admit_year: this.configYear_admitYear,
            admit_semester: this.configYear_admitSemester,
            start_datetime_system: start_datetime_system,
            admit_date: admit_date,
          })
          .catch((error) => {
            this.$toast.error(JSON.stringify(error.response.data.message));
            this.toggle_loading(false);
          });
        this.$store.dispatch("officerConfig/getYears");
        if (response && response.status)
          this.$toast.success(this.$t("toast.edit_successfully"));
        else this.$toast.error(this.$t("toast.cannot_edit"));

        this.toggle_loading(false);
      }
    },
  },
};
</script>
